<template>
	<div class="mainApp">
		<RentsPage ref="rents_page" />
	</div>
</template>

<script>
	import RentsPage from "@/components/RentsPage.vue";

	export default {
		name: "SettlementRentView",
		components: {
			RentsPage,
		},
		data() {
			return {};
		},
		mounted() {
			var appVue = this;
			if (appVue.$store.state.config == null) {
				appVue.$store.dispatch("loadConfig");
			}
			//appVue.$store.dispatch("loadConfig").then(function () {
				
				if (appVue.$store.state.neigh == null) {
					appVue.$store.dispatch("loadNeigh");
				}
				appVue.$store.state.searchType = "SETTLEMENT";
				if (appVue.$route.query.view == "settlement_rent") {
					appVue.$store.state.setlCode = appVue.$route.query.id;
				}

				try {
					appVue.mixin_fetchPageData(
						appVue,
						"SETTLEMENT",
						appVue.$store.state.setlCode,
						appVue.$store.state.config.api_base,
					).then(function () {
						appVue.$store.dispatch("loadSetlTypes").then(() => {
							var setlTypeObj = appVue.$store.state.setlTypes[
								appVue.$store.state.setlCode
							];
							if (setlTypeObj != null) {
								if (setlTypeObj.GLOBAL_TYPE == "קיבוצים"){
									appVue.$store.state.luxury = null;
								}
							}
						});
					});
				} catch (error) {
					console.log("error", error);
					appVue.$router.push({
						name: "notfound",
						query: { view: "notfound" },
					});
				}

				const d_url =
					appVue.$store.state.config.s3_page_base +
					"/settlement/rent/" +
					appVue.$store.state.setlCode +
					".json";
				fetch(d_url)
					.then((response) => response.json())
					.then((data) => {
						appVue.$store.state.settlementName = data.settlementName;
						appVue.$store.state.neighborhoodName = data.neighborhoodName;
						appVue.$store.state.similarNeighborhoods = data.otherNeighborhoods;
						appVue.$store.state.otherSettlmentStreets =
							data.otherSettlmentStreets;
						// check if appVue.$refs.rents_page has a ref called neigh_scroller
						//Do not access Object.prototype method 'hasOwnProperty' from target object
						if (Object.prototype.hasOwnProperty.call(appVue.$refs, "rents_page")){
							if (Object.prototype.hasOwnProperty.call(appVue.$refs.rents_page.$refs, "neigh_scroller")) {
								appVue.$refs.rents_page.$refs.neigh_scroller.similarNeighborhoods =
									data.otherNeighborhoods;
							}
						}
						// else {
						// 	console.log("neigh_scroller not found");
						// }
						appVue.$store.state.isMain = false;
						appVue.mixin_setTrendsData(appVue, data);
					})
					.catch((error) => {
						console.error("Error:", error);
						appVue.$router.push({
							name: "notfound",
							query: { view: "notfound" },
						});
					});
			//});
		},
	};
</script>
